import { getOccTransport } from "~/common/api/occTransport";
import { getCsrfValue } from "~/common/utils/ApiHelper";
import type { GuestRegistrationData } from "~/domains/user/types/GuestRegistrationData";

export interface RegisterUserFields {
  email: string;
  generalTerms: boolean;
  privacyPolicy: boolean;
  marketingConsent?: boolean;
  isRestrictedDomainLimitExceeded?: boolean;
  affiliateId?: string;
  salesPartnerId?: string;
  affiliatePartnerConfirmed?: boolean;
  guestCheckoutContext?: string;
  guestCheckoutData?: GuestRegistrationData;
}

export interface RegisterUserResponse {
  error?: string;
}

export async function registerUser(data: RegisterUserFields): Promise<RegisterUserResponse> {
  const { post, url } = getOccTransport();
  const response = await post(url("/registered-user/registration"), {
    body: JSON.stringify({
      email: data.email,
      generalTerms: data.generalTerms,
      privacyPolicy: data.privacyPolicy,
      marketingConsent: data.marketingConsent ?? false,
      ...(data.isRestrictedDomainLimitExceeded
        ? { isRestrictedDomainLimitExceeded: data.isRestrictedDomainLimitExceeded }
        : {}),
      affiliateId: data.affiliateId ?? null,
      salesPartnerId: data.salesPartnerId ?? null,
      affiliatePartnerConfirmed: data.affiliatePartnerConfirmed ?? false,
      ...(data.guestCheckoutContext
        ? { guestCheckoutContext: data.guestCheckoutContext }
        : data.guestCheckoutData
        ? { guestCheckoutData: data.guestCheckoutData }
        : {}),
    }),
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });

  if (!response.ok) {
    const message = `Error status: ${response.status}, please try again`;
    if (typeof window.alert === "function") {
      window.alert(message);
    }
    throw new Error(message);
  }

  return response.json();
}
